import { notificacoesApi } from '@/api/NotificacoesApi';
import { UploadModel } from "@/models/administracao/comunicacao/UploadModel";
// @ts-ignore
import _ from 'lodash';

export default class NotificacoesService {

  static listarTemplates() {
    return notificacoesApi.listarTemplates();
  }

  static listarGatilhos(): Promise<any[]> {
     return notificacoesApi.listarGatilhos();
  }

  static recuperarConfiguracaoVariaveis(idTemplate: number): Promise<any[]> {
     return notificacoesApi.recuperarConfiguracaoVariaveis(idTemplate);
  }

  static executarConsultar(payload: any) : Promise<any> {
    return notificacoesApi.executarConsultar(payload);  
  }

  static efetuarDisparo(payload: any) : Promise<any> {
    return notificacoesApi.efetuarDisparo(payload);  
  }

  static salvarTemplate(payload:UploadModel) : Promise<any> {
    const UploadDTO = {
      nomeArquivo: payload.nomeArquivo,
      assunto: payload.assunto,
      gatilho: payload.gatilho.id,
      tipoComunicacao: payload.tipoComunicacao.valor,
      conteudoArquivo: payload.conteudoArquivo || undefined,
      variaveis: payload.consulta,
      delayDisparoMinutos: payload.delayDisparoMinutos,
    };
    return notificacoesApi.salvarTemplate(UploadDTO);
  }

  static validarSql(sql:string) : Promise<any> {
    const ValidarSqlDTO = {
        sql: sql
      };
    return notificacoesApi.validarSql(ValidarSqlDTO);  
  }
  
  static downloadTemplate(id: number) : Promise<any> {
    return notificacoesApi.downloadTemplate(id);
  }  

  static excluirTemplate(id: number) {
    return notificacoesApi.excluirTemplate(id);
  }  

  static relatorioDisparo(filtro: any) : Promise<any> {
    const relatorioDTO = {
      cpfCnpj: filtro.cpfCnpj ? filtro.cpfCnpj.replace(/\D/g, "") : undefined,
      tipoComunicacao: filtro.tipoComunicacao?.valor ?? undefined,
      dataEnvio: filtro.dataEnvio ?? undefined
    }
    return notificacoesApi.relatorioDisparo(relatorioDTO);  
  }

  static gerarRelatorioDisparo(tipo: string, filtro: any) {
    const relatorioDTO = {
      cpfCnpj: filtro.cpfCnpj ? filtro.cpfCnpj.replace(/\D/g, "") : undefined,
      tipoComunicacao: filtro.tipoComunicacao?.valor ?? undefined,
      dataEnvio: filtro.dataEnvio ?? undefined
    }
      return notificacoesApi.gerarRelatorioAssociadosInativos(tipo, relatorioDTO);
  }

  static inativarTemplate(id: number): Promise<any> {
      return notificacoesApi.inativarTemplate(id);
  }

  static ativarTemplate(id: number): Promise<any> {
      return notificacoesApi.ativarTemplate(id);
  }

}
